import { render, staticRenderFns } from "./RefreshIconPrimary.vue?vue&type=template&id=6f36a390&"
import script from "./RefreshIconPrimary.vue?vue&type=script&lang=js&"
export * from "./RefreshIconPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports